import React, { useState, useEffect } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import axios from 'api/axios';
import SimpleBarReact from 'simplebar-react';

import DefaultCard from 'components/mycomponents/DefaultCard';
import { dateFormatFull } from 'helpers/dateConverter';

const PassengerSummary = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    // Declare Constant Variable
    const DATA_URL = '/vehicles';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    
    useEffect(() => {
        const getVehicleActivity = async () =>{
            setLoadingData(true);
            try {
                const response = await axios.get(`${DATA_URL}/activity`, {
                    headers: {
                      'Authorization': `Bearer ${TOKEN_APP}`
                    }
                  });
                const responseResult = response?.data;
                const responseData = responseResult?.data;

                setData(responseData);

                setLoadingData(false);
                
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    console.log(response.message);
                } else {
                    console.log('Something error with server. Please call administrator or developer.');
                }
            }
        }

        getVehicleActivity()
    }, [TOKEN_APP]);
    return (
        <DefaultCard>
            <DefaultCard.Header title={'Daftar Absensi Armada Angkutan Sekolah'} />
            <DefaultCard.Body>
                <h6 className="mb-2">Tanggal : {dateFormatFull()}</h6>
                <SimpleBarReact style={{maxHeight: 250}}>
                    <Table hover responsive bordered size="sm">
                        <thead>
                            <tr>
                                <th scope="col">No</th>
                                <th scope="col">No. Kendaraan</th>
                                <th scope="col">Driver</th>
                                <th scope="col">Mulai</th>
                                <th scope="col">Selesai</th>
                                <th scope="col">Jumlah Siswa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loadingData ? (<tr>
                                    <td colSpan={7} align="center" valign="middle">
                                        <Spinner animation="border  " className="me-2" />
                                        <span className="fs-4">Loading ...</span>
                                    </td>
                                </tr>) :
                                data ? data.map((val, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{val.vcnopol}</td>
                                            <td align="center">{val.vcdriver}</td>
                                            <td align="center">{val.timestart}</td>
                                            <td align="center">{val.timestop}</td>
                                            <td align="center">{val.jmlsiswa}</td>
                                        </tr>
                                    )
                                }) : (
                                    <tr>
                                        <td colSpan={5} align="center" valign="middle">
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                </SimpleBarReact>
            </DefaultCard.Body>
        </DefaultCard>
    )
}

PassengerSummary.propTypes = {}

export default PassengerSummary;